// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * windowFrame.css
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

html.groupMask body {
	background-color: var(--groupMask-background-color);
	border: 1px solid var(--groupMask-border-color);
	margin: 0;
}

html.highlightScrim body {
	background-color: var(--groupMask-border-color);
	outline: 5px solid var(--groupMask-border-color);
	outline-offset: -5px;
	margin: 0;
	width: 100vw;
	height: 100vh;
}

html:is(.groupMask, .highlightScrim) html::before {
	height: 0;
}

html:is(.groupMask, .highlightScrim) html::after {
	width: 0;
	top: 0;
	right: 0;
	bottom: 0;
}

html:is(.groupMask, .highlightScrim) body::before {
	height: 0;
	right: 0;
	bottom: 0;
	left: 0;
}

html:is(.groupMask, .highlightScrim) body::after {
	width: 0;
	top: 0;
	bottom: 0;
	left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/assets/css/core/windowFrame.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;CACC,mDAAmD;CACnD,+CAA+C;CAC/C,SAAS;AACV;;AAEA;CACC,+CAA+C;CAC/C,gDAAgD;CAChD,oBAAoB;CACpB,SAAS;CACT,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,QAAQ;CACR,MAAM;CACN,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,SAAS;CACT,QAAQ;CACR,SAAS;CACT,OAAO;AACR;;AAEA;CACC,QAAQ;CACR,MAAM;CACN,SAAS;CACT,OAAO;AACR","sourcesContent":["/*!\n * windowFrame.css\n * Copyright 2017 - 2020 by ChartIQ, Inc.\n * All rights reserved.\n */\n\nhtml.groupMask body {\n\tbackground-color: var(--groupMask-background-color);\n\tborder: 1px solid var(--groupMask-border-color);\n\tmargin: 0;\n}\n\nhtml.highlightScrim body {\n\tbackground-color: var(--groupMask-border-color);\n\toutline: 5px solid var(--groupMask-border-color);\n\toutline-offset: -5px;\n\tmargin: 0;\n\twidth: 100vw;\n\theight: 100vh;\n}\n\nhtml:is(.groupMask, .highlightScrim) html::before {\n\theight: 0;\n}\n\nhtml:is(.groupMask, .highlightScrim) html::after {\n\twidth: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\nhtml:is(.groupMask, .highlightScrim) body::before {\n\theight: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n}\n\nhtml:is(.groupMask, .highlightScrim) body::after {\n\twidth: 0;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
